import { z } from 'zod';

/**
 * Адрес страницы «Мои задачи»: `?role=assignee&done=true&group=space`.
 *
 * Как и у доски (4.1), состояние живёт в адресе: ссылку можно сохранить и
 * отправить себе же. Некорректное значение отбрасывается, а не роняет
 * страницу — `catch(undefined)` на каждом поле.
 */
export const myTasksSearchSchema = z.object({
  role: z.enum(['assignee', 'reviewer']).optional().catch(undefined),
  done: z.boolean().optional().catch(undefined),
  group: z.enum(['due', 'space', 'priority']).optional().catch(undefined),
});

export type MyTasksSearch = z.infer<typeof myTasksSearchSchema>;
